import React from 'react';

import { Button, ButtonSizes } from 'atoms';
import {
  BurnCardAmount,
  BurnCardContent,
  BurnCardText,
  ButtonWrapper,
  ShuffleText,
  WindowBurnCard,
  WindowBurnCardContent,
  WindowShuffleContent,
} from './styles';

interface IProps {
  isBurnCardWindow: boolean;
  isShuffleWindow: boolean;
  burnCardAmount: number;
  closeBurnCardWindow: () => void;
  closeShuffleWindow: () => void;
}

export const WindowBurnShuffleCard = ({
  isBurnCardWindow,
  isShuffleWindow,
  burnCardAmount,
  closeBurnCardWindow,
  closeShuffleWindow,
}: IProps) =>
  isBurnCardWindow || isShuffleWindow ? (
    <WindowBurnCard>
      {isBurnCardWindow && (
        <WindowBurnCardContent backgroundColor="#FF0505" borderColor="#FF0505A3">
          <BurnCardContent>
            <BurnCardAmount>{burnCardAmount}</BurnCardAmount>
            <BurnCardText>Burn Card</BurnCardText>
          </BurnCardContent>
          <ButtonWrapper>
            <Button onClick={closeBurnCardWindow} size={ButtonSizes.md}>
              Close
            </Button>
          </ButtonWrapper>
        </WindowBurnCardContent>
      )}
      {isShuffleWindow && (
        <WindowShuffleContent backgroundColor="#FF7C09" borderColor="#F38144CC">
          <ShuffleText>Shuffle</ShuffleText>
          <ButtonWrapper>
            <Button onClick={closeShuffleWindow} size={ButtonSizes.md}>
              Close
            </Button>
          </ButtonWrapper>
        </WindowShuffleContent>
      )}
    </WindowBurnCard>
  ) : null;
